import { RumInitConfiguration } from '@datadog/browser-rum';

import { APP_CONFIG } from '../app';
import { beforeSend } from './beforeSend';

export const DATADOG_CONFIG: RumInitConfiguration = {
  applicationId: 'f9d7c1b5-28e8-4077-ac71-2f1fd115fcfe',
  beforeSend,
  clientToken: 'pubce6058d25ed5f83364517630a8a07cc7',
  defaultPrivacyLevel: 'mask',
  enableExperimentalFeatures: ['feature_flags'], // Enables sending feature flag values along with Datadog events.
  env: APP_CONFIG.environment,
  excludedActivityUrls: [(url) => url.startsWith('https://heapanalytics.com/h?')],
  service: 'dashboard-ui',
  sessionReplaySampleRate: 0,
  sessionSampleRate: 100,
  site: 'datadoghq.com',
  trackLongTasks: true,
  trackResources: true,
  trackUserInteractions: true,
  version: 'latest', // This is a static value used to sync Datadog sourcemap uploads from MFEs.
};
